import { Pencil } from "lucide-react"
import React from "react"

/**
 * Props for the EditButton component.
 */
interface EditButtonProps {
  /**
   * Optional ID for the button element.
   */
  id: string

  /**
   * Function to execute when the button is clicked.
   */
  onClick?: () => void

  /**
   * Determines whether the button is disabled.
   * Defaults to `false`.
   */
  disabled?: boolean
}

/**
 * EditButton component renders a circular button with a pencil (edit) icon.
 * It supports optional click handling and a disabled state.
 *
 * @param {EditButtonProps} props - The properties for the EditButton component.
 * @returns {JSX.Element} The rendered edit button.
 */
const EditButton: React.FC<EditButtonProps> = ({
  id,
  onClick,
  disabled = false,
}) => {
  return (
    <button
      data-automation-id={id}
      id={id}
      onClick={onClick}
      disabled={disabled}
      className={`text-blue-600 hover:text-blue-900 ${disabled ? "text-gray-400 cursor-not-allowed" : ""}`}>
      <span className={`inline-flex items-center justify-center w-8 h-8 bg-gray-200 rounded-full ${disabled ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-300"}`}>
        <Pencil size={16} />
      </span>
    </button>
  )
}

export default EditButton